import { SectionModelType } from './section.type';
import { WorkoutSportType } from './sport.type';

/** Modes Kinomap vers lesquels un fichier ZWO peut etre converti. */
export type ZwoImportMode = 'ftp' | 'watts';

/**
 * Ecart entre le fichier ZWO et le workout produit, a remonter a l'utilisateur.
 * - `zone_converted` : puissance donnee en zone Zwift, convertie en % FTP moyen de la zone.
 * - `free_ride_converted` : bloc libre (FreeRide / MaxEffort), remplace par une valeur par defaut.
 * - `ramp_split` : rampe decoupee en paliers constants.
 * - `value_clamped` : valeur hors des bornes du mode, ramenee dans les bornes.
 * - `duration_adjusted` : duree inferieure au minimum d'une section, allongee.
 * - `test_ignored` : marqueur de test FTP / ramp test, ignore.
 * - `unsupported_block` : bloc inconnu, ignore.
 */
export type ZwoImportWarningCode =
  | 'zone_converted'
  | 'free_ride_converted'
  | 'ramp_split'
  | 'value_clamped'
  | 'duration_adjusted'
  | 'test_ignored'
  | 'unsupported_block';

export type ZwoImportWarning = {
  code: ZwoImportWarningCode;
  block: string;
  blockIndex: number;
};

export type ZwoImportErrorCode =
  'invalid_file' | 'unsupported_sport' | 'unsupported_duration_type' | 'empty_workout';

export class ZwoImportError extends Error {
  constructor(public readonly code: ZwoImportErrorCode) {
    super(`ZWO import failed: ${code}`);
    this.name = 'ZwoImportError';
  }
}

export type ZwoImportResult = {
  name?: string;
  description?: string;
  author?: string;
  sport: WorkoutSportType;
  mode: ZwoImportMode;
  sections: SectionModelType[];
  warnings: ZwoImportWarning[];
};
